import React from 'react';
import { DropdownItem, DropdownItemsWrapper, DropdownWrapper } from './Dropdown.styled';
import { Divider } from '@emarketer/componentlibrary';

export interface IDropdown {
  items: IDropdownItem[];
  callback: any;
  maxHeight?: string;
  maxItems?: number;
}

export interface IDropdownItem {
  label: string;
  value: string;
}

const Dropdown: React.FC<IDropdown> = (props) => {
  const { items, callback, maxHeight, maxItems } = props;

  const dropdownItems = items.slice(0, maxItems).map((item, index) => (
    <DropdownItem
      key={index}
      buttonType="none"
      callback={(e) => {
        e.stopPropagation();
        callback(item);
      }}
    >
      {item.label}
    </DropdownItem>
  ));

  return (
    <DropdownWrapper maxHeight={maxHeight} limitOnVisibility={false} scrollbarOffset={4}>
      <DropdownItemsWrapper divider={<Divider width="100%" />} spaceBetween={0}>
        {dropdownItems}
      </DropdownItemsWrapper>
    </DropdownWrapper>
  );
};

export default Dropdown;
